import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data.user);
        navigate(data.user.role === "admin" ? "/admin/leads" : "/portal", { replace: true });
      })
      .catch((err) => {
        setUser(false);
        if (err.response?.status === 403) navigate("/access-restricted", { replace: true });
        else navigate("/login", { replace: true, state: { error: "Google sign-in failed. Please try again." } });
      });
  }, [navigate, setUser]);

  return <div data-testid="auth-callback" className="min-h-screen bg-[#07090E]" />;
}
